import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {PosesListComponent} from './poses-list.component';
import {PosesService} from './poses.service';
import {Observable} from 'rxjs/Observable';
import {NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import {SucursalesService} from '../sucursales/sucursales.service';
import {ISucursal} from '../sucursales/sucursal';
import * as $ from 'jquery';

@Component({
  selector: 'pm-add-pos',
  templateUrl: './add-pos.component.html',
  styleUrls: ['./add-pos.component.sass']
})
export class AddPosComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'POS';

  posIdentifierSelected: string;
  pinPadIdentifierSelected: string;
  merchantSelected: number;
  statusSelected: number;

  merchantList: Observable<ISucursal[]> = this.merchantService.getSucursales();

  constructor(
    private parent: PosesListComponent,
    public service: PosesService,
    private merchantService: SucursalesService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.resetForm();
  }

  resetForm(form?: NgForm) {
    if (form != null) {
      form.resetForm();
    }
    this.service.formData = {
      id: 0, // 1,
      posIdentifier: '', // 00083000,
      pinPadIdentifier: '', // 00083000,
      merchantId: '', // 210,
      merchantName: '', // Puerta la Victoria,
      status: '' // 1
    };
  }

  ngAfterViewInit() {
    $('a[rel=pos]').addClass('selected');
  }

  cancelPos(): void {
    this.parent.showPoses = true;
    this.parent.showAddPos = false;
  }

  addPos(form: NgForm): void {
    console.log('addPos: form: ', form);
    if (form.invalid) {
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }

    form.value.merchantId = parseInt(form.value.merchantId);
    form.value.status = parseInt(form.value.status);
    console.log('addPos: form 2: ', form.value);

    this.parent.showPoses = true;
    this.parent.showAddPos = false;
    this.service.addPos(form.value).subscribe(
      res => {
        this.router.navigate(['/pos']);
      },
      err => console.log('addPos: err: ', err)
    );
  }

  ngOnDestroy() {
    $('a[rel=pos]').removeClass('selected');
  }
}
